import request from "@/utils/request";

// 信息列表
export async function getList(params) {
  return request.get("nxin.information.content.list/1.0", {
    params
  });
}
